// import { onMounted } from "vue";
// import { useStore } from "@/system_modules/store";
import { G } from "@/_common";


function getTitle(vm) {
    const { title } = vm.$options

    if (title) {
        if( typeof title === 'function' ){
            return title(vm);
        }
        else{
            return title;
        }
    }
    // else{
    //     return name;
    // }
}

export default {
    // setup(){
    //     onMounted(() => {
    //         const title = getTitle(this)
    //         if (title) {
    //             document.title = 'DIARC - ' + title
    //         }
    //     });
    // }
    created() {
        setTimeout(() => {
            const title = getTitle(this)
            if (title) {
                // document.title = G.projectName.replaceAll(/(<[^>]*>)/gi, '').trim() + ' - ' + (G.lang[title] || title)
                document.title = (G.lang[title] || title);
            }
        }, 300);
    }
}